import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiInstagram,FiFacebook,FiArrowUp} = FiIcons;

function Footer({onAdmin}) {
  const scrollTop = () => window.scrollTo({top: 0,behavior: 'smooth'});

  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <div className="capucine-mark inverse">C</div>
        <h2>Girl In Paris<sup>®</sup></h2>
        <p>Stories and objects for your next chapter.</p>
      </div>
      <div className="footer-links">
        <div><strong>Read</strong><a href="#stories">The Edit</a><a href="#stories">Nine Lives</a><a href="#stories">The Salon</a></div>
        <div><strong>Discover</strong><a href="#about">Our Story</a><a href="#shop">Little Shop</a><a href="#shop">Subscriptions</a></div>
        <div><strong>Follow</strong><a href="#home"><SafeIcon icon={FiInstagram} /> Instagram</a><a href="#home"><SafeIcon icon={FiFacebook} /> Facebook</a></div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Girl In Paris® · All rights reserved</span>
        <div className="footer-admin-actions">
          <button onClick={onAdmin}>Admin controls</button>
          <button onClick={scrollTop}>Back to the top <SafeIcon icon={FiArrowUp} /></button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;